"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyNavLink = void 0;
const epic_games_nav_shared_1 = require("epic-games-nav-shared");
const react_1 = __importStar(require("react"));
const shared_1 = require("../../../shared");
const mainLinkUtils_1 = require("../../../utils/mainLinkUtils");
const styled_components_1 = __importDefault(require("styled-components"));
const Styled = styled_components_1.default.a `
    cursor: pointer;
`;
const LegacyNavLink = ({ link = {}, locale = 'en-US', className, tabIndex, children, disableHrefTemplate, onClick, onMouseDown }) => {
    const closeMenus = (0, shared_1.useCloseAllMenus)();
    const defaultOnClickHandlingAndCloseMenus = (0, shared_1.useCloseMenusLinkClick)(link);
    const target = !disableHrefTemplate ? (0, mainLinkUtils_1.getLinkTarget)(link) : '';
    let finalHref = link.href;
    if (link.useCustomCallback && !disableHrefTemplate) {
        const { localeHref } = (0, epic_games_nav_shared_1.getHrefWithLocale)(Object.assign(Object.assign({}, link), { locale }));
        finalHref = localeHref;
    }
    const { isExternal, sameOrigin } = (0, epic_games_nav_shared_1.determineExternal)(finalHref);
    const safe = !isExternal || sameOrigin;
    const rel = safe ? '' : 'noopener noreferrer';
    const attrs = {};
    if (finalHref) {
        attrs.href = finalHref;
    }
    if (target) {
        attrs.target = target;
    }
    if (rel) {
        attrs.rel = rel;
    }
    const navLinkOnClick = (0, react_1.useCallback)((e) => {
        closeMenus();
        if (onClick && typeof onClick === 'function') {
            onClick(e);
        }
        else if (link.onClick && typeof link.onClick === 'function') {
            link.onClick(e);
        }
        else {
            defaultOnClickHandlingAndCloseMenus(e);
        }
    }, [onClick, link]);
    if (!children)
        return null;
    return (react_1.default.createElement(Styled, Object.assign({}, attrs, { className: `navlink ${className || ''}`, onClick: navLinkOnClick, tabIndex: tabIndex, onMouseDown: onMouseDown || epic_games_nav_shared_1.stopFocusOnClick, role: "menuitem" }), children));
};
exports.LegacyNavLink = LegacyNavLink;
//# sourceMappingURL=LegacyNavLink.atom.js.map